export type CardPrimaryAction = 'next' | 'done';

export const getCardPrimaryActionAndHasBack = ({
  stepIndex,
  totalSteps,
  isForwardStepOnly,
}: {
  stepIndex: number;
  totalSteps: number;
  isForwardStepOnly: boolean;
}): {
  hasBack: boolean;
  primaryAction: CardPrimaryAction;
} => ({
  hasBack: stepIndex > 0 && !isForwardStepOnly,
  primaryAction: stepIndex === totalSteps - 1 ? 'done' : 'next',
});
